const inlineSVG = require('inline-svg/src/inlineSVG.js');

export default function () {
    inlineSVG.init({
        svgSelector: '.inline-svg img[src$=".svg"]',
        initClass: 'js-inline-svg',
    });
}
